import apiSurveys from '../api/survey';

let DefaultState = () => {
    return {
        Surveys: [],
        loading: false,
        Objectives: []
    };
};

export default {
    state: DefaultState(),
    getters: {
        HealthGuideSurveys_Get: state => () => {
            return state.Surveys;
        },
        HealthGuideSurveys_GetObjectives: state => () => {
            return state.Objectives;
        }
    },
    mutations: {
        HEALTH_GUIDE_SURVEYS_RESET_STATE(state) {
            Object.assign(state, DefaultState());
        },
        HEALTH_GUIDE_SURVEYS_ADD(state, Survey) {
            state.Surveys.push(Survey);
        },
        HEALTH_GUIDE_SURVEYS_LOAD(state, Surveys) {
            state.Surveys = Surveys;
            state.loading = false;
        },
        HEALTH_GUIDE_SURVEYS_OBJECTIVES(state, Objectives) {
            state.Objectives = Objectives;
        }
    },
    actions: {
        Recipes_ResetState({commit}) {
            commit('HEALTH_GUIDE_SURVEYS_RESET_STATE');
        },
        HealthGuideSurveys_Add({commit}, Survey) {
            commit('HEALTH_GUIDE_SURVEYS_ADD', Survey);
        },
        HealthGuideSurveys_Update({commit}, Surveys) {
            commit('HEALTH_GUIDE_SURVEYS_UPDATE', Surveys);
        },
        HealthGuideSurveys_FindByUser({commit, state}, UserID) {
            state.loading = true;
            apiSurveys.FindByUser(UserID).then(res => {
                if (typeof res.data !== 'undefined' && res.data.length) { commit('HEALTH_GUIDE_SURVEYS_LOAD', res.data); }
            });
        },
        HealthGuideSurveys_GetObjectives({commit, state}) {
            apiSurveys.getObjectives().then(res => {
                if (typeof res.data !== 'undefined' && res.data.length) { commit('HEALTH_GUIDE_SURVEYS_OBJECTIVES', res.data); }
            });
        }
    }
};
